import { BrbIcon, HandIcon, HandRaiseFilledIcon } from "@100mslive/react-icons";
import { Flex, Tooltip } from "@100mslive/react-ui";
import { selectIsConnectedToRoom, useHMSStore } from "@100mslive/react-sdk";
import { useTranslation } from "react-i18next";

import { FEATURE_LIST } from "../common/constants";
import IconButton from "../IconButton";
import { useEffect } from "react";
import { useIsFeatureEnabled } from "./hooks/useFeatures";
import { useMyMetadata } from "./hooks/useMetadata";

const MetaActions = ({
  isMobile = false,
  isHandRaised,
  isBRBOn,
  compact = false,
  toggleHandRaise,
  toggleBRB,
}) => {
  const isConnected = useHMSStore(selectIsConnectedToRoom);
  const isHandRaiseEnabled = useIsFeatureEnabled(FEATURE_LIST.HAND_RAISE);
  const isBRBEnabled = useIsFeatureEnabled(FEATURE_LIST.BRB);
  const { t } = useTranslation();
  if (!isConnected || (!isHandRaiseEnabled && !isBRBEnabled)) {
    return null;
  }

  return (
    <Flex align="center" css={{ gap: compact ? "$4" : "$8" }}>
      {isHandRaiseEnabled && (
        <Tooltip
          title={!isHandRaised ? t("lbl_hands_up") : t("lbl_hands_down")}
        >
          <IconButton
            onClick={toggleHandRaise}
            active={!isHandRaised}
            data-testid={`${
              isMobile ? "raise_hand_btn_mobile" : "raise_hand_btn"
            }`}
            css={{
              color: isHandRaised ? "$yellow" : "$white",
            }}
          >
            {isHandRaised ? <HandRaiseFilledIcon /> : <HandIcon />}
          </IconButton>
        </Tooltip>
      )}
      {/* {isBRBEnabled && (
        <Tooltip
          title={`${isBRBOn ? `Tôi đã quay lại` : `Tôi sẽ quay lại sau`}`}
        >
          <IconButton
            onClick={toggleBRB}
            active={!isBRBOn}
            data-testid="brb_btn"
            css={{
              color: isBRBOn ? "$yellow" : "$white",
            }}
          >
            <BrbIcon />
          </IconButton>
        </Tooltip>
      )} */}
    </Flex>
  );
};

export default MetaActions;
